import React from 'react'
import Header from '../../component/Header/Header'
import HomeHero from '../../component/HomeHero/HomeHero'
import Footer from '../../component/Footer/Footer'
import BoxedContent from '../../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../../component/BoostCard/BoostCard'
import TeamLdCare from '../../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../../component/BoostshootRowCard/BoostshootRowCard'
import MembershipCustomTextContent from '../../component/MembershipCustomTextContent/MembershipCustomTextContent'
import { Helmet } from 'react-helmet'

const listData = [
     {
        img:"/images/creatives/medicalAesthetic-text-1.png",
        title:"Why it matters",
        para:"Healthy, confident skin supports self-esteem and reflects wellness."
    },
     {
        img:"/images/creatives/medicalAesthetic-text-1.png",
        title:"Who it’s for",
        para:"Ideal for individuals interested in anti-aging, skin rejuvenation, or targeted aesthetic concerns."
    },
    //  {
    //     img:"/images/creatives/medicalAesthetic-text-1.png",
    //     title:"How it works",
    //     para:"Physician consultation, customized treatment plan, and a series of safe, proven interventions."
    // },
]


const cardList = [
  {
     link:"/iv-therapy-boost-shots",
        img:"/images/creatives/service-main-8.webp",
    name:"IV Therapy",
    rank:"",
    para:'Restore energy and hydration with customized vitamin and mineral infusions.'
  },
  {
     link:"/naturopathic-medicine",
        img:"/images/creatives/service-main-9.webp",
    name:" Naturopathic Medicine ",
    rank:"",
    para:'An integrative approach combining clinical science and natural therapies to optimize health.'
  },
]

const boostCardData = [
    "Restore skin firmness and elasticity",
    "Minimize fine lines, wrinkles, and texture issues",
    "Support even skin tone and glow",
    "Enhance confidence through a natural look",
]

function MedicalAesthetics() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
      <Helmet>
        <title>
        Advanced Medical Aesthetics | The Toronto Clinic
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/medical-aesthetics"
        />
        <meta
          name="description"
          content="The Toronto Clinic offers advanced, physician-supervised aesthetic treatments that rejuvenate skin, enhance tone, and promote a natural, healthy glow."
        ></meta>
      </Helmet>
         <Header/>
        <HomeHero
            heading='Medical Aesthetics'
            content='Advanced, medically supervised aesthetic treatments for natural, confident results.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
             btnText='Book a Consultation'
            btnrefTel='https://booking.thetorontoclinic.com/services-general'
            sideImage={"/images/creatives/medicalAesthetichero-image.png"}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
            btnCalnedly={true}
            calendlyType={10}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className='pt-4'></div>
          <BoxedContent
            heading="Formulas for an empowered you"
            para="Our Medical Aesthetics program blends evidence-based cosmetic procedures with physician oversight to help you look and feel your best. We emphasize subtle, rejuvenating treatments that respect your natural beauty while achieving visible results."
            bgImg="/images/creatives/service-main-6.webp"
          />

            <MembershipCustomTextContent
            listData={listData}
            shiftRow={true}
            nonSwitchingImg={true}
            heading={"Step Into a World Where Advanced Aesthetic Technology and Artistic Precision Come Together to Reveal the Most Radiant Version of You"}
          />

        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        <div style={{backgroundImage:"url(/images/creatives/boost-shoot-bg.png)",backgroundPosition:"center",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>

        <BoostCard
          cardContentProp={boostCardData}
        />

        
        <div className='pt-4'></div>
       <TeamLdCare
          heading=''
          spanHeading="Enhance your experience"
          paragraph=""
          showBtn={false}
          cardData={cardList}
          noSwiper={true}
       /> 
        <div className='pb-4'></div>
        
        </div>
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
        <HomeProgram
          mainCardHeading="The path to health begins here, take the first step"
          mainCardPara="At The Toronto Clinic, we redefine healthcare with a proactive, deeply personalized approach. Designed to support your longevity and well-being, our program ensures you stay at your peak: healthy, confident, and in control."
          btnText="Explore membership"
          btnRef="/membership"
          mainCardImg={"/images/creatives/membership-text-2.png"}
          showList={false}
          leftBottomBorderRadius={true}
          backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default MedicalAesthetics